import * as React from 'react'
import { Button, Input, Segment } from 'semantic-ui-react'
import { InputOnChangeData } from 'semantic-ui-react/dist/commonjs/elements/Input/Input'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { toast } from 'react-toastify'
import { adminService } from '../../../../../services'
import { HistoryTransaction } from './HistoryTransaction'
import { common } from '../../../../../utils/common'

type AdminTransactionState = {
  isLoading: boolean,
  depRequestId?: number,
  depRequestAmount?: number,
  showPopup: boolean,
  depRequest?: IDepositRequest,
}

export default class AdminTransaction extends React.Component {
  state: AdminTransactionState = {
    isLoading: false,
    showPopup: false,
  }

  onChangeDepRequestId = (event: React.SyntheticEvent<HTMLInputElement>, data: InputOnChangeData) => {
    this.setState({
      depRequestId: data.value
    })
  }

  onChangeDepRequestAmount = (event: React.SyntheticEvent<HTMLInputElement>, data: InputOnChangeData) => {
    this.setState({
      depRequestAmount: Number(data.value.replace(/[\D\s\._\-]+/g, ''))
    })
  }

  onClickApproveButton = () => {
    const {depRequestId} = this.state
    if (!depRequestId) {
      toast.error('Không được để trống mã yêu cầu nạp tiền!')
      return
    }
    this.setState({isLoading: true})
    adminService.getDepRequestInfo(depRequestId)
      .then(depRequest => {
        this.setState({
          isLoading: false,
          depRequest: depRequest,
          showPopup: true,
          depRequestAmount: common.calculateFee(depRequest.amount, depRequest.feeFactor)
        })
      }).catch(error => {
      toast.error(error.message)
    })
  }

  onClickConfirmButton = () => {
    const {depRequestAmount, depRequestId} = this.state
    if (!depRequestId || !depRequestAmount) {
      toast.error('Mã yêu cầu nạp tiền và số tiền nạp không được để trống!')
      return
    }
    const approveDepRequestInfo: IApproveDepRequestInfo = {
      amount: depRequestAmount,
      depRequestId: depRequestId
    }
    this.setState({isLoading: true})
    adminService.approveDeptRequest(approveDepRequestInfo)
      .then(value => {
        this.setState({
          isLoading: false,
          showPopup: false,
        })
        toast.success('Nạp tiền thành công!')
      }).catch(error => {
      toast.error('Nạp tiền không thành công! Thông tin: ' + error.message)
      this.setState({
        isLoading: false,
        showPopup: false,
      })
    })
  }

  toggle() {
    const {showPopup} = this.state
    this.setState({
      showPopup: !showPopup
    })
  }

  render() {
    const {isLoading, depRequestId, depRequestAmount, showPopup, depRequest} = this.state
    const totalAmount = depRequest ? common.calculateFee(depRequest.amount, depRequest.feeFactor) : 0
    return (
      <div>
        <Segment loading={isLoading}>
          <Input value={depRequestId} label={'Mã yêu cầu nạp tiền'} onChange={this.onChangeDepRequestId}/>
          <Button color={'blue'} onClick={this.onClickApproveButton}> Approve </Button>
        </Segment>
        <HistoryTransaction/>
        <Modal isOpen={showPopup} toggle={this.toggle}>
          <ModalHeader>Xác nhận</ModalHeader>
          <ModalBody>
            {depRequest &&
            <div>
              Bạn có đồng ý nạp tiền cho user [{depRequest.message}]:
              <br/>id: {depRequest.id}
              <br/>Ngân hàng thực hiện: {depRequest.bank}
              <br/>Số tiền khách muốn nạp: {depRequest.amount.toLocaleString('en-US')}
              <br/>Phí: {depRequest.feeFactor ? `${(depRequest.feeFactor * 100).toLocaleString('vn')} %` : '0'}
              <br/>Số tiền yêu cầu nạp: {totalAmount.toLocaleString('en-US')}
              <br/>Số tiền thực chuyển:
              <Input
                value={depRequestAmount ? depRequestAmount.toLocaleString('en-US') : 0}
                onChange={this.onChangeDepRequestAmount}
              />
            </div>
            }
          </ModalBody>
          <ModalFooter>
            <Button color={'green'} onClick={this.onClickConfirmButton}>XÁC NHẬN</Button>
            <Button color={'red'} onClick={() => this.setState({showPopup: false})}>KHÔNG</Button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/HomeRoll/modules/Admin/containers/AdminTransaction.tsx